import React from 'react'
import styles from '../Hero.css'
import PropTypes from "prop-types"

const HeaderBoldLightSub = React.forwardRef((props, ref) => {
  const {header_bold, header_light, header_sub} = props

  return (
    <div
      ref={ref}
      className={styles.headers}
    >
      {header_bold &&
      <h1 dangerouslySetInnerHTML={{__html: header_bold}}/>
      }
      {header_light &&
      <h1 className='secondary' dangerouslySetInnerHTML={{__html: header_light}}/>
      }
      {header_sub &&
      <p className={styles.subHeader} dangerouslySetInnerHTML={{__html: header_sub}}/>
      }
    </div>
  )
})

HeaderBoldLightSub.propTypes = {
  header_bold: PropTypes.string,
  header_light: PropTypes.string,
  header_sub: PropTypes.string
}

export default HeaderBoldLightSub



// WEBPACK FOOTER //
// ./src/components/Hero/partials/HeaderBoldLightSub.js